<div class="h-full w-full" style="position: relative; height: 100%;">
  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <div class="loading-text">Loading data...</div>
  </div>

  <div class="ag-theme-alpine h-full w-full" [class.hidden]="isLoading">
    <!-- Tooltip for pin functionality -->
    <!-- <div *ngIf="rowData.length > 0" class="pin-tooltip">
      Right-click on column headers to pin/unpin columns
    </div> -->
    
    <ag-grid-angular
      *ngIf="rowData.length > 0"
      style="height: 100%; width: 100%;"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [statusBar]="gridOptions.statusBar"
      (gridReady)="onGridReady($event)"
      [getRowStyle]="getRowStyle"
    ></ag-grid-angular>
    
    <div *ngIf="rowData.length === 0 && !isLoading" class="text-center py-8">
      No data available
    </div>
  </div>
</div>
